import React from 'react'
import './motionView.scss'

export default class MotionViewBackground extends React.Component {

  	shouldComponentUpdate(nextProps) {
		const { backgroundOptions, inEditMode } = this.props		
		
		if(nextProps.inEditMode !== inEditMode) {
			return true;
		}		

    	if (nextProps.backgroundOptions.bgRandomTimestamp === backgroundOptions.bgRandomTimestamp) {
      		return false;
		}

		if(nextProps.backgroundOptions.customImage === backgroundOptions.customImage) {
			return false;
		}

    	return true;
	}
	
	render() {

    	const {
			backgroundOptions,
			inEditMode
		} = this.props;
		const { showBgColor, bgColor, bgRandom, bgRandomTimestamp, customImage, bgOpacity } = backgroundOptions;
		const backgroundUrl = bgRandom ? bgRandomTimestamp : customImage ? customImage : null;

    	return <div 
			className='motionView__bg'
			style={{
					backgroundColor: !bgRandom && showBgColor
					? bgColor
					: 'transparent',
					backgroundImage: backgroundUrl 
					? `url('${backgroundUrl}')`
					: '',
					opacity: inEditMode ? '.3' : '1',
			}}			
			>
			{backgroundUrl && <div className="tint-overlay" style={{opacity: (100 - bgOpacity) / 100}}></div>}
			<CustomImage />

		</div>
	}
}

class CustomImage extends React.Component {

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return <img className="motionView__bg-custom" />
	}
}